import { requestGet } from '@/common/request';

export interface channelOperationParams {}

export interface channelOperationRes {
  ret: string;
  msg: string;
  data: {
    operation: Array<{ type: number; desc: string }> | [];
    sex: Array<{ type: number; desc: string }> | [];
    identity: Array<{ type: number; desc: string }> | [];
    hobby: Array<{ type: number; desc: string }> | [];
    property: Array<{ type: number; desc: string }> | [];
  };
  systemTime: any;
}

//频道运营信息相关
export async function channelOperation(params: channelOperationParams): Promise<channelOperationRes> {
  return await requestGet('/channelActivity/channelOperation', params);
}
